export const paths = {
  // Sections
  ips: 'cdaReader',
  alerts: 'alerts',
  dailyMonitoring: 'dailyMonitoring',
  somatometrics: 'somatometrics',
  medicalProblems: 'medicalProblems',
  medicalHistorySection: 'medicalHistory',
  pregnancy: 'pregnancy',
  gynaecology: 'gynaecology',
  hysteroscopy: 'hysteroscopy',
  medicationSummary: 'medicationSummary',
  socialHistory: 'socialHistory',
  laboratory: 'laboratory',
  imaging: 'imaging',
  healthCarePlan: 'carePlan',
  careTeam: 'careTeam',
  travelHistory: 'travelHistory',
  episodeOfCare: 'episodeOfCare',
  pilotStudy: 'pilotStudy',
  tracheostomy: 'tracheostomy',
  etiology: 'etiology',
  complication: 'complication',
  comorbidity: 'comorbidity',
  preciousAi: 'preciousAi',
  patientCharacteristics: 'patientCharacteristics',
  initialAssessments: 'initialAssessments',
  departmentalQuestionnaires: 'departmentalQuestionnaires',
  pilotQuestionnaires: 'pilotQuestionnaires',
  selfReport: 'selfReport',

  // Sub-items
  vitalSigns: 'vitalSigns',
  arterialBloodGas: 'arterialBloodGas',
  glasgow: 'glasgow',
  glucose: 'glucose',
  nutritionIntake: 'nutritionIntake',
  neck: 'neckSize',
  weight: 'weight',
  allergies: 'allergies',
  medicalAlert: 'medicalAlert',
  vaccinations: 'vaccinations',
  resolvedProblems: 'resolvedProblems',
  medicalHistory: 'medical',
  currentProblems: 'currentProblems',
  devicesAndImplants: 'deviceAndImplants',
  procedures: 'procedures',
  currentMedicines: 'medicines',
  pastMedicines: 'pastMedicines',
  activeEpisodeOfCare: 'activeEpisodeOfCare',
  pastEpisodeOfCare: 'pastEpisodeOfCare',

  // socialHistoryObservations: 'socialHistoryObservations',
  // socialHistoryQuestionnaire: 'socialHistoryQuestionnaire',

  laboratoryFiles: 'laboratoryFiles',
  laboratoryResults: 'laboratoryResults',

  imagingFiles: 'imagingFiles',
  multipleSclerosisSegmentation: 'multipleSclerosisSegmentation',
  preciousMedSamSegmentation: 'preciousMedSamSegmentation',
  protectMedSamSegmentation: 'protectMedSamSegmentation',

  ctParameters: 'ctParameters',
  tubeCharacteristics: 'tubeCharacteristics',
  capnography: 'capnography',
  hysteroscopyFiles: 'hysteroscopyFiles',

  socialQuestionnaireAmen: 'socialQuestionnaireAmen',
  supportingDocumentsAmen: 'supportingDocumentsAmen',
  fastProtocolQuestionnaireMediterrenean:
    'fastProtocolQuestionnaireMediterrenean',
  strokeScoreQuestionnaireMediterrenean:
    'strokeScoreQuestionnaireMediterrenean',

  // Departmental Questionnaire
  // Speech
  speechTherapyQuestionnaire: 'speechTherapyQuestionnaire',
  geriatricDepressionScale: 'geriatricDepressionScale',
  parkinsonsQuestionnaire: 'parkinsonsQuestionnaire',
  becksDepressionInventory: 'becksDepressionInventory',
  oralClinicalAssessmentOfDeposition: 'oralClinicalAssessmentOfDeposition',
  // Physiotherapy
  physiotherapyQuestionnaire: 'physiotherapyQuestionnaire',
  bergBalanceScale: 'bergBalanceScale',
  patientAssessmentCard: 'patientAssessmentCard',
  sldcQuestionnaire: 'sldcQuestionnaire',
  slagQuestionnaire: 'slagQuestionnaire',

  // Pilot Questionnaires
  // Veles
  velesQuestionnaires: 'velesQuestionnaires',
  dn4: 'dn4',
  pdquestionnaire: 'pdquestionnaire',
  eq5d: 'eq5d',
  pacslac2: 'pacslac2',
  painad: 'painad',
  mobid: 'mobid',

  // Workspace
  workspace: {
    myPatients: 'myPatients',
    incomingReferrals: 'incomingReferrals',
    outgoingReferrals: 'outgoingReferrals',
  },

  // Tenant Management
  tenantManagement: {
    userManagement: 'userManagement',
    careTeamTemplates: 'careTeamTemplates',
  },
};
